import { io } from "socket.io-client";

let defaultOptions = {
    nickname: 'anonymous',
    maxMessageLength: 360,
    reconnection: true,
    reconnectionDelay: 5000,
    reconnectionDelayMax: 60000,
    reconnectionAttempts: 12,
    transports: [ 'websocket' ]
};

class BaseChat {

    constructor(url, options) {
        this.options = {
            ...defaultOptions,
            ...options
        }

        this.nickname = this.options.nickname;
        this.maxMessageLength = this.options.maxMessageLength;
        
        this.socket = io(url, {
            reconnection: this.options.reconnection,
            reconnectionDelay: this.options.reconnectionDelay,
            reconnectionDelayMax: this.options.reconnectionDelayMax,
            reconnectionAttempts: this.options.reconnectionAttempts,
            transports: this.options.transports
        });
    }

    on(eventType, func) {
        this.socket.on(eventType, func);
    }

    off(eventType, func) {
        this.socket.off(eventType, func);
    }

    joinRoom(room) {
        this.socket.emit('join', room);
    }

    sendMessage(message) {
        if(!message) {
            return;
        }

        if(this.maxMessageLength > 0 && message.length > this.maxMessageLength) {
            message = message.substring(0, this.maxMessageLength);
        }

        this.socket.emit('message', {
            nickname: this.nickname,
            message: message
        });
    }

}

export default BaseChat;